import React from 'react';

export default function KPICards({ summary, accentColor, accentText }) {
  if (!summary) return null;

  const cards = [
    { label: 'TOTAL', value: summary.totalContainers },
    { label: 'FREMONT', value: (summary.byTerminal?.FET?.atTerminal || 0) + (summary.byTerminal?.FET?.onTrain || 0) },
    { label: 'AMARILLO', value: (summary.byTerminal?.AMA?.atTerminal || 0) + (summary.byTerminal?.AMA?.onTrain || 0) },
    { label: 'AT TERMINAL', value: summary.atTerminal },
    { label: 'ON TRAIN', value: summary.onTrain },
    { label: 'AT PORT', value: summary.atPort },
  ];

  return (
    <div className="grid grid-cols-6 gap-3">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-lg p-3 text-center"
          style={{ backgroundColor: accentColor, color: accentText === 'dark' ? '#333' : '#fff' }}
        >
          <div className="text-2xl font-bold">{card.value === 0 ? '–' : card.value}</div>
          <div className="text-xs mt-0.5 opacity-80">{card.label}</div>
        </div>
      ))}
    </div>
  );
}
